import { message } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { assetApi } from '@services/assetApi';
import { TAssetPhotoContext, TPhotoItem } from '../constant';
import { ASSET_PHOTO_CONSTANT } from '../constant';

const { MESSAGE } = ASSET_PHOTO_CONSTANT;

function useAssetPhotoInquiry() {
  const { assetId } = useParams<{ assetId: string }>();
  const navigate = useNavigate();

  const [assetInfo, setAssetInfo] = useState<TAssetPhotoContext | null>(null);
  const [photos, setPhotos] = useState<TPhotoItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState<number>(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    if (!assetId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    assetApi
      .getAssetById(assetId)
      .then((res) => {
        if (!res.ok || !res.data) {
          message.error(MESSAGE.E01);
          return;
        }
        const d = res.data;
        setAssetInfo({
          asset_no: d.assetCode ?? '',
          asset_name: d.assetName ?? '',
          company_code: d.companyOriginCode ?? '',
          company_name: d.companyOriginName ?? '',
          store_code: d.storeCode ?? '', // '' until BE G1 fix ships
          store_name: d.storeName ?? '', // '' until BE G1 fix ships
        });
        // BE already sorts photos capturedAt DESC — use order as-is
        const mapped: TPhotoItem[] = d.photos.map((p) => ({
          id: p.s3ObjectKey ?? p.originalFileName ?? '',
          file_path: p.thumbnailPresignedUrl ?? p.originalPresignedUrl ?? '',
          taken_at: p.capturedAt ? p.capturedAt.split('T')[0] : null,
        }));
        setPhotos(mapped);
      })
      .catch(() => {
        message.error(MESSAGE.E01);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [assetId]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleThumbnailClick = (index: number) => {
    setSelectedPhotoIndex(index);
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handlePrevPhoto = () => {
    setSelectedPhotoIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNextPhoto = () => {
    setSelectedPhotoIndex((prev) => Math.min(photos.length - 1, prev + 1));
  };

  return {
    state: {
      assetInfo,
      photos,
      isLoading,
      selectedPhotoIndex,
      isDialogOpen,
    },
    handler: {
      handleBack,
      handleThumbnailClick,
      handleDialogClose,
      handlePrevPhoto,
      handleNextPhoto,
    },
  };
}

export default useAssetPhotoInquiry;
